

import React, { Component } from 'react'
import PlayerController from '../../components/player/PlayerController'
import shuffle from 'shuffle-array'
import AppBar from 'material-ui/AppBar';
import Drawer from 'material-ui/Drawer';
import Subheader from 'material-ui/Subheader';
import MenuItem from 'material-ui/MenuItem';
import './Player.css'


class Player extends Component {

    constructor(props) {
        super(props)
        this.deviceId = props.match.params.playerId
        this.width = window.screen.width
        this.height = window.screen.height
        this.state = {
            loadingStyle: { width: this.width, height: this.height },
            open: false
        }

    }

    componentDidMount = () => {
        if (this.deviceId) {
            this.loadPlayer()
        } else {
            this.createPlayer()
        }
        document.body.style.overflow = "hidden"
    }

    componentWillUnmount = () => {
        document.body.style.overflow = "auto"
    }

    openDrawer = () => {
        this.setState({ open: true })
    }

    closeDrawer = () => {
        this.setState({ open: false })
    }


    loadPublicPlaylists = async () => {
        let request = await fetch(`https://papirodev.appspot.com/_ah/api/public/v1/playlists`)
        let playlists = await request.json()
        this.props.device.playlists = playlists
        this.setState({ playlists: playlists })
    }

    loadPlayer = async () => {
        let deviceInfo = await (await fetch(`https://papirodev.appspot.com/_ah/api/api/v2/findDeviceById/${this.deviceId}`)).json()
        this.loadPlayerPlaylists(deviceInfo);
    }

    loadPlayerPlaylists = async (deviceInfo) => {
        this.setState({ deviceCode: deviceInfo.publicAccessCode })
        let request = await fetch(`https://papirodev.appspot.com/_ah/api/api/v2/devices/${this.deviceId}?serviceKey=test&deviceVersion=2017110600`, { method: 'POST' })
        let device = await request.json()
        device.toReproduce = [];
        device.accessCode = deviceInfo.publicAccessCode
        device.mainImageDownloadUrl = deviceInfo.mainImageDownloadUrl
        if (device.ads) {
            for (let i = 0; i < device.ads.length; i++) {
                let ad = device.ads[i]
                if (ad.type === 'container') {
                    this.loadPlaylist(device, ad)
                }
            }
        }
    }

    loadTemporalPlaylist = async (playerId, query, cursor, retries = 0) => {
        let playlist = await this.fetchTemporalPlaylist(playerId, query, cursor);
    }

    fetchTemporalPlaylist = async (playerId, query, cursor, retries = 0) => {
        try {
            query = query ? encodeURIComponent(query) : "";
            cursor = cursor ? encodeURIComponent(cursor) : "";
            let request = await fetch(`https://papirodev.appspot.com/_ah/api/public/v1/findTemporalPonplaylist/${playerId}?query=${query}&cursor=${cursor}`);
            let response = await request.json();
            if (response.error) {
                if (retries < 3) {
                    return await this.fetchTemporalPlaylist(playerId, query, cursor, retries + 1);
                }
                return [];
            }
            return response;
        } catch (err) {
            if (retries < 3) {
                return await this.fetchTemporalPlaylist(playerId, query, cursor, retries + 1);
            }
            return [];
        }
    }

    loadPlaylist = async (device, ad) => {
        let containerRequest = await fetch(`https://papirodev.appspot.com/_ah/api/api/v2/devices/${this.deviceId}/publications/${ad.id}/ads?deviceVersion=2017110600`, { method: 'POST' })
        let container = await containerRequest.json()
        if (container.ads) {
            container.ads = shuffle(container.ads)
            device.toReproduce.push(...container.ads)
            device.toReproduce = shuffle(device.toReproduce)
            this.setState({ device: device })
        } else {
            await this.loadPlaylist(device, ad)
        }
    }

    createPlayer = async () => {
        let info = {};
        let selectedPlaylists = [{ kind: 'Playlist', id: '6653385620586496' }];
        let playerInfo = { playlists: selectedPlaylists };
        let request = await fetch(`https://papirodev.appspot.com/_ah/api/api/v2/devices/new?alt=json`,
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(playerInfo)
            })
        let device = await request.json()
        window.ga('send', { hitType: 'event', eventCategory: "freemium", eventAction: 'create-player', eventLabel: device.publicAccessCode });
        this.props.history.push(`/player/${device.code}?publicCode=${device.publicAccessCode}`);
        this.deviceId = device.code;
        this.loadPlayerPlaylists(device);
    }

    render() {
        return (

            <div className="player-page">
                {
                    this.state.device ? (<PlayerController width={this.width} height={this.height} device={this.state.device} />) : (
                        <div className="loading-page">
                            <div className="loading-page-content" style={this.state.loadingStyle}>
                                <h1 className="loading-text">Cargando...</h1>
                                {this.state.deviceCode ?
                                    <div className="player-help">
                                        <div className="player-help-description">Dile a tus amigos que ingresen a ponmusica.com y voten por sus canciones favoritas</div>
                                        <br /><br /><br />
                                        <div className="player-help-code-container">Código: <br /><span className="player-help-code">{this.state.deviceCode}</span></div>
                                    </div> : null}
                            </div>
                        </div>
                    )
                }
            </div>

        )
    }
}

export default Player



// WEBPACK FOOTER //
// ./src/pages/player/Player.js